import undoIcon from 'common/assets/img/undo.png'
import redoIcon from 'common/assets/img/redo.png'
import { Image } from '@chakra-ui/react';
import "common/assets/css/text-editor.css";

const CustomToolbar = ({ toolbarId })  => {
    return (
        <div className='customToolbar' id={toolbarId}>
            <div className="CustomToolbar">
                <div className='CustomToolbarSection'>
                    <button className="ql-undo">
                        <Image src={undoIcon} boxSize='16px' />
                    </button>
                    <button className="ql-redo">
                        <Image src={redoIcon} boxSize='24px' />
                    </button>
                </div>

                <div className="CustomToolbarSection">
                    <select className="ql-font"></select>
                    <select className="ql-size"></select>
                </div>

                <div className='CustomToolbarSection'>
                    <button className="ql-bold"></button>
                    <button className="ql-italic"></button>
                    <button className="ql-underline"></button>
                    <button className="ql-strike"></button>
                    <select className="ql-color"></select>
                    <select className="ql-background"></select>
                </div>

                <div className='CustomToolbarSection'>
                    <select className="ql-align"></select>
                    <button className="ql-list" value="ordered"></button>
                    <button className="ql-list" value="bullet"></button>
                    <button className="ql-clean"></button>
                </div>
            </div>
        </div>
    );
};

export default CustomToolbar